import axios from "axios";
import { AXIOS_CONFIG } from "../api";
import { backend_url } from "@/constants.ts";
import { Endpoints } from "@api/endpoints.ts";

export interface SearchResponse {
  /**
   * ID of client.
   */
  userId: string;
  /**
   * Email of client.
   */
  email: string;
  /**
   * Name of client.
   */
  firstName: string;
  /**
   * Last name of client.
   */
  lastName: string;
  /**
   * Filters by status.
   */
  status?: string;
}

export interface SearchResponseWithMeta {
  results: SearchResponse[];
  availableTaxYears?: number[];
}

/**
 * Searches the taxpro's client list using params and returns client identifiers.
 * @param params Params to filter clients by.
 */
export const getSearchResults = async (
  params?: object
): Promise<SearchResponseWithMeta> => {
  try {
    const response = await axios.get(
      `${backend_url}/${Endpoints.clients.search}`,
      {
        params,
        ...AXIOS_CONFIG,
      }
    );
    const content = response.data.content;
    return {
      results: Array.isArray(content.results)
        ? content.results
        : [content.results],
      availableTaxYears: content.availableTaxYears || [],
    };
  } catch (error) {
    console.error("Error fetching clients:", error);
    throw error;
  }
};
